export default __webpack_public_path__ + "static/potential-3b3e388e26d00c711293dd6fd5cbdce9.png";